import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getReportsStore from "../../../stores/reports-store";
import Et3Date from "../../../core/et3-input/et3-date";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../core/et3-div";

const DatePicker = withLiteObserverAndTheme<{ notPendingReport: boolean }>(
  (props) => {
    const { notPendingReport, theme } = props;
    const { colors } = theme;
    return notPendingReport ? (
      <React.Fragment>
        <Et3Margin top={15} bottom={0} right={0} left={0} />
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          withShadow={false}
          width={1200}
          height={75}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Date
            hasMax={true}
            hasMin={false}
            label={i18n.get("DATE_MIN")}
            dateInputObservable={getReportsStore().fromDate}
            isEnabled={true}
          />
          <Et3Margin top={0} bottom={0} right={30} left={0} />
          <Et3Date
            hasMax={true}
            hasMin={false}
            label={i18n.get("DATE_MAX")}
            dateInputObservable={getReportsStore().toDate}
            isEnabled={true}
          />
        </ET3Div>
      </React.Fragment>
    ) : null;
  }
);

export default DatePicker;
